// JS
var input_selector =
  'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';

function updateTextFields() {
  $(input_selector).each(function (index, element) {
    var $this = $(this);
    var inputId = $this.attr('id');
    if (
      $(element).val().length > 0 ||
      $(element).is(':focus') ||
      element.autofocus
    ) {
      $('label[for="' + inputId + '"]').addClass('active');
      $('#' + inputId).addClass('valid');
    } else if ($(element)[0].validity) {
      $('label[for="' + inputId + '"]').toggleClass(
        'active',
        $(element)[0].validity.badInput === true,
      );
    } else {
      $('label[for="' + inputId + '"]').removeClass('active');
    }
    if ($(element).is(':focus')) {
      $('label[for="' + inputId + '"]').addClass('focusing');
    } else {
      $('label[for="' + inputId + '"]').removeClass('focusing');
    }
  });
}

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 1) {
    $('sticky-header').addClass('active');
  } else {
    $('sticky-header').removeClass('active');
  }
});

jQuery.fn.scrollCenter = function (elem, speed) {
  // this = #timepicker
  // elem = .active

  var active = jQuery(this).find(elem); // find the active element
  //var activeWidth = active.width(); // get active width
  var activeWidth = active.width() / 2; // get active width center

  //alert(activeWidth)

  //var pos = jQuery('#timepicker .active').position().left; //get left position of active li
  // var pos = jQuery(elem).position().left; //get left position of active li
  //var pos = jQuery(this).find(elem).position().left; //get left position of active li
  var pos = active.position().left + activeWidth; //get left position of active li + center position
  var currentscroll = jQuery(this).scrollLeft(); // get current scroll position
  var divwidth = jQuery(this).width(); //get div width
  //var divwidth = jQuery(elem).width(); //get div width
  pos = pos + currentscroll - divwidth / 2; // for center position if you want adjust then change this

  jQuery(this).animate(
    {
      scrollLeft: pos,
    },
    speed == undefined ? 1000 : speed,
  );
  return this;
};

// http://podzic.com/wp-content/plugins/podzic/include/js/podzic.js
jQuery.fn.scrollleft = function (elem, speed) {
  jQuery(this).animate(
    {
      scrollLeft:
        jQuery(this).scrollLeft() -
        jQuery(this).offset().left +
        jQuery(elem).offset().left,
    },
    speed == undefined ? 1000 : speed,
  );
  return this;
};

$(document).ready(function () {
  $('.product-i-change').click(function () {
    $('.i_change-popup').addClass('active');
  });
  $('.i_change-close,.i_change-overlay').click(function () {
    $('.i_change-popup').removeClass('active');
  });

  /**
   * Check select onclick
   *
   */
  $('.dropdown > .caption').on('click', function () {
    $(this).parent().toggleClass('open');
  });

  $('.dropdown > .list > .item').on('click', function () {
    $('.dropdown > .list > .item').removeClass('selected');
    var data = $(this).data('url');
    $(this)
      .addClass('selected')
      .parent()
      .parent()
      .removeClass('open')
      .children('.caption')
      .attr('data-value', data)
      .text($(this).text());

    window.location.href = data;
  });

  $(document).on('keyup', function (evt) {
    if ((evt.keyCode || evt.which) === 27) {
      $('.dropdown').removeClass('open');
    }
  });

  $(document).on('click', function (evt) {
    if ($(evt.target).closest('.dropdown > .caption').length === 0) {
      $('.dropdown').removeClass('open');
    }
  });

  /**---------- END ----------*/

  /**
   * Check select option selected.
   *
   */
  let url = window.location.href;
  $('.curreny_container .item').each(function () {
    var urlOption = $(this).data('url');
    if (url.indexOf(urlOption) > -1) {
      $(this)
        .addClass('selected')
        .parent()
        .parent()
        .removeClass('open')
        .children('.caption')
        .attr('data-value', urlOption)
        .text($(this).text());
    }
  });
  /**---------- END ----------*/

  /**---------- GIFD CARD CUSTOMIZE ----------*/
  $('.gift_card .select__select ').on('change', function () {
    setInterval(function () {
      var textSelect = $('.gift_card .select__select option')
        .filter(':selected')
        .text();
      var textTrim = $.trim(textSelect);
      var text = $('.product-form__submit .btn-text').html();
      jQuery('.submit_gift_card .btn-text').text(text);
      if (
        textTrim == 'Select Price' ||
        text == 'Sold out' ||
        text == 'Unavailable'
      ) {
        jQuery('.submit_gift_card').prop('disabled', true);
      } else {
        jQuery('.submit_gift_card').prop('disabled', false);
      }
    }, 2000);
  });

  var textSelect = $('.gift_card .select__select option')
    .filter(':selected')
    .text();
  var textTrim = $.trim(textSelect);
  var text = $('.product-form__submit .btn-text').html();
  jQuery('.submit_gift_card .btn-text').text(text);
  if (
    textTrim == 'Select Price' ||
    text == 'Sold out' ||
    text == 'Unavailable'
  ) {
    jQuery('.submit_gift_card').prop('disabled', true);
  } else {
    jQuery('.submit_gift_card').prop('disabled', false);
  }

  jQuery('.gift_card .submit_gift_card').click(function (e) {
    e.preventDefault();
    $('.gift_card_form').valid();
    var recipientEmail = jQuery('#recipient-email').val();
    var recipientName = jQuery('#recipient-name').val();
    var elementInput = jQuery('.property_form input');
    if (recipientEmail && recipientName) {
      if (!elementInput.hasClass('error')) {
        $('.product-form__submit').trigger('click');
        $(this).addClass('loading');
      }
    }
  });

  setInterval(function () {
    jQuery('.gift_card .submit_gift_card').removeClass('loading');
  }, 5000);

  $('body').on('mouseenter', '.R-RatingSelection__item', function () {
    $(this).prevAll().addClass('isShowStar');
  });
  $('body').on('mouseleave', '.R-RatingSelection__item', function () {
    $(this).prevAll().removeClass('isShowStar');
  });
  $('body').on('mouseenter', '.R-RatingSelection__item', function () {
    $(this).nextAll().addClass('isNotShowStar');
  });
  $('body').on('mouseleave', '.R-RatingSelection__item', function () {
    $(this).nextAll().removeClass('isNotShowStar');
  });

  $(document).mouseup(function (event) {
    var target = event.target;
    var select = $('.country_select');
    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass('open');
      $('.currency').removeClass('active');
    }
  });

  jQuery('#ContactFooter').validate({
    // use highlight and unhighlight
    highlight: function (element, errorClass, validClass) {
      jQuery(element.form)
        .find('label[for=' + element.id + ']')
        .addClass('error-label');
      if (element.type === 'radio') {
        this.findByName(element.name)
          .addClass(errorClass)
          .removeClass(validClass);
      } else {
        jQuery(element).addClass(errorClass).removeClass(validClass);
      }
    },
    unhighlight: function (element, errorClass, validClass) {
      jQuery(element.form)
        .find('label[for=' + element.id + ']')
        .removeClass('error-label');
      if (element.type === 'radio') {
        this.findByName(element.name)
          .removeClass(errorClass)
          .addClass(validClass);
      } else {
        jQuery(element).removeClass(errorClass).addClass(validClass);
      }
    },
  });

  jQuery('#ContactQuiz').validate({
    // use highlight and unhighlight
    highlight: function (element, errorClass, validClass) {
      jQuery(element.form)
        .find('label[for=' + element.id + ']')
        .addClass('error-label');
      jQuery(element.form).find('label.field__label').addClass('error-label');
      if (element.type === 'radio') {
        this.findByName(element.name)
          .addClass(errorClass)
          .removeClass(validClass);
      } else {
        jQuery(element).addClass(errorClass).removeClass(validClass);
      }
    },
    unhighlight: function (element, errorClass, validClass) {
      jQuery(element.form)
        .find('label.field__label')
        .removeClass('error-label');
      if (element.type === 'radio') {
        this.findByName(element.name)
          .removeClass(errorClass)
          .addClass(validClass);
      } else {
        jQuery(element).removeClass(errorClass).addClass(validClass);
      }
    },
  });

  $('.product__items').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          variableWidth: true,
        },
      },
    ],
  });

  $('.blog__posts-items').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  var input_stockist = '.page-become-a-stockist .nf-form-row input';
  if ($(input_stockist).hasClass('nf-form-control')) {
    $(input_stockist).addClass('input-group__field');
    $(input_stockist).removeClass('nf-form-control');
  }
  var button_stockist = '.page-become-a-stockist .nf-form-row button';
  if ($(button_stockist).hasClass('nf-btn')) {
    $(button_stockist).removeClass('nf-btn-primary');
    $(button_stockist).addClass('input-button');
    $(button_stockist).removeClass('nf-btn');
  }
  var select_stockist = '.page-become-a-stockist .nf-form-row select';
  if ($(select_stockist).hasClass('nf-form-control')) {
    $(select_stockist).removeClass('nf-custom-select');
    $(select_stockist).removeClass('nf-form-control');
  }

  var textarea_stockist = '.page-become-a-stockist .nf-form-row textarea';
  if ($(textarea_stockist).hasClass('nf-form-control')) {
    $(textarea_stockist).addClass('input-group__field');
    $(textarea_stockist).removeClass('nf-textarea');
    $(textarea_stockist).removeClass('nf-form-control');
  }

  $(input_stockist).each(function () {
    var sd = $(this).attr('placeholder');
    $(this)
      .closest('.nf-input-group')
      .append('<label class="field__label">' + sd + '</label>');
    $(this).attr('placeholder', ' ');
  });

  $(textarea_stockist).each(function () {
    var sd = $(this).attr('placeholder');
    $(this)
      .closest('.nf-input-group')
      .append('<label class="field__label">' + sd + '</label>');
    $(this).attr('placeholder', ' ');
  });

  var select_bisiness = '.nf-input-group select';
  if ($(select_bisiness).hasClass('nf-custom-select')) {
    $(select_bisiness).removeClass('nf-custom-select');
  }

  /**
   * check val select
   */
  $(document).ready(function () {
    $('body')
      .find('select')
      .each(function () {
        if (
          (($(this).attr('data-default') != '---' &&
            $(this).attr('data-default') != '') ||
            ($(this).val() && $(this).attr('data-default') != '---')) &&
          $(this).val() != '---'
        ) {
          $(this).addClass('has-value');
        }
      });
  });
  $(document).on('change', 'select', function () {
    if ($(this).val() != '---' && $(this).val() != '') {
      $(this).addClass('has-value');
    } else {
      $(this).removeClass('has-value');
    }
  });

  $('.banner-content__text .read-more-result').click(function () {
    $('html, body').animate(
      {
        scrollTop: $('.skin-concern').offset().top,
      },
      1000,
    );
  });

  /**
   *
   * Event skin quiz page
   */
  $('.advisement').hide();
  $('.start-quiz').on('click', function () {
    $('.section--skin-quiz').fadeOut();
    $('.section--step').css('display', 'flex');
    $('[data-step="1"]').fadeIn(500);
    $('.step-1').addClass('active');
    window.scrollTo(0, 0);
  });
  $(
    '.section--step .left-section .quiz-question .options:not(.options--btn) .option',
  ).on('click', function () {
    if ($(this).hasClass('active') == false) {
      $(this).parents('.options').find('.option').removeClass('active');
      $(this).parents('.options').find('.option').next().removeAttr('checked');
      $(this).addClass('active');
      $(this).next().attr('checked', true);
      $(this).parent().addClass('checked');
    }
    let count = $(this)
      .parents('.quiz-question')
      .find('.options:not(.options--btn)').length;
    let accept = $(this)
      .parents('.quiz-question')
      .find('.options.checked:not(.options--btn)').length;

    if (count == accept)
      $(this)
        .parents('.quiz-question')
        .find('.btn.next')
        .removeClass('btn--disabled');
  });

  function cbNext(nextOk, self) {
    if (nextOk == true) {
      $(self).find('.btn.next').removeClass('btn--disabled');
    } else {
      if (!$(self).find('.btn.next').hasClass('btn--disabled')) {
        $(self).find('.btn.next').addClass('btn--disabled');
      }
    }
  }

  $(
    '.section--step .left-section .quiz-question:not(.quiz-question-1):not(.quiz-question-2)',
  ).each(function () {
    var self = $(this);
    var nextOk = true;
    $(self)
      .find('select')
      .each(function () {
        $(this).change(function () {
          $(self)
            .find('select')
            .each(function () {
              if ($(this).val() == '---') {
                nextOk = false;
                return false;
              } else {
                nextOk = true;
              }
            });
          cbNext(nextOk, self);
        });

        if ($(this).val() != '---') {
          $(self).find('.next.btn--disabled').removeClass('btn--disabled');
        }
      });
  });

  function step5() {
    var answer1 = $('[name="answer-1"][checked="checked"]').val();
    var step5 = '5';
    switch (answer1) {
      case 'skinconcern:[anti-ageing]':
        step5 = '5-1';
        break;
      case 'skinconcern:[acne]':
        step5 = '5-2';
        break;
      case 'skinconcern:[dry]':
        step5 = '5-3';
        break;
      case 'skinconcern:[sensitive]':
        step5 = '5-4';
        break;
      case 'skinconcern:[hyperpigmentation]':
        step5 = '5-5';
        break;
      case 'skinconcern:[oily]':
        step5 = '5-6';
        break;
      case 'skinconcern:[generalskinmaintenance]':
        step5 = '5-7';
        break;
    }
    $('[data-step^="5-"]').hide();
    $('[data-step="' + step5 + '"]').fadeIn(500);
  }

  for (let i = 2; i <= 6; i++) {
    $('.btn.step-' + i).on('click', function () {
      if (i >= 5) {
        $('.steps li').removeClass('active');
        $('.steps li.step-' + i).addClass('active');
        $('.steps').scrollCenter('.active', 300);
      }
      $('.step').removeClass('active');
      $('.step.step-' + i).addClass('active');
      $('.section--step').attr('data-section-step', i);

      if (i != 5) $('[data-step^="' + i + '"]').fadeIn(500);
      else step5();

      $('[data-step^="' + (i - 1) + '"]').hide();
      window.scrollTo(0, 0);
    });
    $('.back.step-' + i).on('click', function () {
      if (i <= 3) {
        $('.steps li').removeClass('active');
        $('li.step-' + (i - 1)).addClass('active');
        $('.steps').scrollCenter('.active', 300);
      }
      $('.step').removeClass('active');
      $('.step.step-' + (i - 1)).addClass('active');
      $('[data-step^="' + i + '"]').hide();
      $('.section--step').attr('data-section-step', i - 1);

      if (i - 1 != 5) {
        $('[data-step^="' + (i - 1) + '"]').fadeIn(500);
        $('.section--step').attr('data-section-step', i - 1);
      } else step5();

      window.scrollTo(0, 0);
    });
  }
  var valueDropdownClass = '.dropdown-skin-quiz .place-holder';
  $('.dropdown-skin-quiz').click(function () {
    $(this).toggleClass('active');
  });

  $('.dropdown-skin-quiz + .dropdown li').click(function () {
    var text = $(this).text();
    var value = $(this).data('value');
    $(this).closest('.options').find('.dropdown-skin-quiz').val(text);
    $(this).closest('.options').find('.dropdown-skin-quiz-hidden').val(value);
    $(this)
      .closest('.options')
      .find('.dropdown-skin-quiz')
      .toggleClass('active');
    if (text != '---') {
      $(this)
        .closest('.quiz-question')
        .find('.btn')
        .removeClass('btn--disabled');
    } else {
      $(this).closest('.quiz-question').find('.btn').addClass('btn--disabled');
    }
  });

  function getTags() {
    var ok = true;
    var answer1 = $('[name="answer-1"][checked="checked"]').val();
    var answer3 = $('[name="answer-3"][checked="checked"]').val();
    var answer4 = $('[name="answer-4"][checked="checked"]').val();
    var arrayTags = new Array();
    arrayTags.push(answer1);
    arrayTags.push(answer3);
    arrayTags.push(answer4);

    var step5 = '5';
    switch (answer1) {
      case 'skinconcern:[anti-ageing]':
        step5 = '5-1';
        break;
      case 'skinconcern:[acne]':
        step5 = '5-2';
        break;
      case 'skinconcern:[dry]':
        step5 = '5-3';
        break;
      case 'skinconcern:[sensitive]':
        step5 = '5-4';
        break;
      case 'skinconcern:[hyperpigmentation]':
        step5 = '5-5';
        break;
      case 'skinconcern:[oily]':
        step5 = '5-6';
        break;
      case 'skinconcern:[generalskinmaintenance]':
        step5 = '5-7';
        break;
    }

    $('[data-step="' + step5 + '"]')
      .find('[name^="answer-' + step5 + '-"][checked="checked"]')
      .each(function () {
        if (
          $(this).attr('name') != 'answer-5-1-1' &&
          $(this).attr('name') != 'answer-5-2-2' &&
          $(this).attr('name') != 'answer-5-4-2' &&
          $(this).attr('name') != 'answer-5-5-1' &&
          $(this).attr('name') != 'answer-5-6-2'
        ) {
          if ($(this).val().search('|') != -1) {
            let array = $(this).val().split('|');
            array.forEach((element) => {
              if (element) arrayTags.push(element);
            });
          } else {
            arrayTags.push($(this).val());
          }
        }
      });

    var objectTags = {};
    arrayTags.forEach((element) => {
      let pos = element.search(':');
      let key = element.substring(0, pos);
      objectTags[key] = element;
    });
    localStorage.setItem('listTags', Object.values(objectTags));

    return objectTags;
  }

  const quizSubscribe = async (email, listId) => {
    if (email && listId) {
      const settings = {
        async: true,
        crossDomain: true,
        url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        data: {
          g: `${listId}`,
          $fields: '$email,$source',
          $email: `${email}`,
          $source: 'Skin Quiz',
        },
      };

      $.ajax(settings)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          console.log(err);
          return err;
        });
    }
  };

  $('#send-mail-aws').click(function () {
    var results = getTags();
    var email = $('#aws-email').val();
    if (email == '') {
      document.location.href = '/pages/skin-result';
    } else {
      var postUrl =
        `https://${window.CD_STATE.aws.url}.execute-api.ap-southeast-2.amazonaws.com/${window.CD_STATE.aws.env}/quiz/?userEmail=` +
        email;
      var dataSend = JSON.stringify({
        email: email,
        results: results,
      });

      $.ajax({
        type: 'POST',
        url: postUrl,
        data: dataSend,
        headers: {'content-type': 'application/json'},
        dataType: 'json',
        success: function (data) {
          console.log(data);
          $('.quiz-question-6').find('.form-message').remove();
          var messHtml =
            "<div class='form-message form-message--success' tabindex='-1'>";
          messHtml +=
            '<div>Send the quiz results successfully! Page will redirect after 2s...</div>';
          messHtml += "<label class='close-notification'>";
          messHtml +=
            "<img src='" +
            $('.quiz-question-6 .img-hidden.img-hidden--success').val() +
            "' alt='Close Notification'>";
          messHtml += '</label>';
          messHtml += '</div>';
          $(messHtml).insertBefore('.quiz-question-6 .options');
          setTimeout(function () {
            $('.quiz-question-6 .form-message').remove();
          }, 3000);
        },
        error: function (data) {
          console.log(data);
          $('.quiz-question-6').find('.form-message').remove();
          var messHtml =
            "<div class='form-message form-message--error' tabindex='-1'>";
          messHtml += '<div>Send the quiz results fail!</div>';
          messHtml += "<label class='close-notification'>";
          messHtml +=
            "<img src='" +
            $('.quiz-question-6 .img-hidden.img-hidden--error').val() +
            "' alt='Close Notification'>";
          messHtml += '</label>';
          messHtml += '</div>';
          $(messHtml).insertBefore('.quiz-question-6 .options');
          setTimeout(function () {
            $('.quiz-question-6 .form-message').remove();
          }, 3000);
        },
        beforeSend: function () {
          $(document.body).css({cursor: 'wait'});
        },
        complete: function () {
          $(document.body).css({cursor: 'default'});

          if ($('#sign-up').is(':checked')) {
            const form = document.getElementById('quiz-subscribe');
            const data = new FormData(form);
            const req = fetch(
              'https://a.klaviyo.com/ajax/subscriptions/subscribe',
              {
                method: 'POST',
                body: data,
              },
            );
          }

          setTimeout(function () {
            document.location.href = '/pages/skin-result';
          }, 2000);
        },
      });
    }
  });

  /**
   *
   */
  let width = $(window).width();

  if (width < 580) {
    $('.item-sub-menu .headding').on('click', function () {
      if ($(this).parents('.item-sub-menu').hasClass('open')) {
        $(this).parents('.item-sub-menu').find('.site-nav-sub').slideUp();
        $(this).parents('.item-sub-menu').removeClass('open');
      } else {
        $(this).parents('.item-sub-menu').find('.site-nav-sub').slideUp();
        $(this)
          .parents('.item-sub-menu')
          .find('.item-sub-menu')
          .removeClass('open');

        $(this).parents('.item-sub-menu').find('.site-nav-sub').slideDown();
        $(this).parents('.item-sub-menu').addClass('open');
      }
    });
  }

  $('.skin-result .banner .read-more').on('click', function () {
    if ($(this).parents('.banner-content__text').hasClass('open')) {
      $(this)
        .parents('.banner-content__text')
        .find('span')
        .css('display', 'none');
      $(this).parents('.banner-content__text').removeClass('open');
      $(this).text('Read more');
    } else {
      // $(this).parents('.banner-content__text').find('span').slideUp();
      $(this).parents('.banner-content__text').removeClass('open');

      $(this)
        .parents('.banner-content__text')
        .find('span')
        .css('display', 'inline');
      $(this).parents('.banner-content__text').addClass('open');
      $(this).text('Read less');
    }
  });

  $('.readmore').click(function (event) {
    console.log('click');
    event.preventDefault();
    $(this).parents('.product-description-short').next().show();
    $(this).parents('.product-description-short').hide();
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    $(this).parents('.product-description-full').prev().show();
    $(this).parents('.product-description-full').hide();
  });

  // remove notification
  $(document).on('click', '.close-notification', function () {
    let that = jQuery(this);
    window.history.replaceState(null, null, window.location.href.split('?')[0]);
    that.parents('.form-message').remove();
  });

  $('.product-form__error-message-wrapper .close-notification').click(
    function () {
      $('.product-form__error-message-wrapper').addClass(
        'product-form__error-message-wrapper--hidden',
      );
    },
  );

  // Text based inputs
  var input_selector =
    'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';

  // Add active if form auto complete
  $(document).on('change', input_selector, function () {
    var inputId = $(this).attr('id');
    if (
      $(this).val().length !== 0 ||
      $(this).attr('placeholder') !== undefined
    ) {
      $('label[for="' + inputId + '"]').addClass('active');
    }
  });

  var isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  var isSafari =
    /Safari/.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor);
  if (isChrome || isSafari) {
    jQuery(document).ready(function () {
      setTimeout(function () {
        if ($('input:-webkit-autofill')) {
          $('input:-webkit-autofill').each(function () {
            if ($(this).val().length !== '') {
              var inputId = $(this).attr('id');
              $('label[for="' + inputId + '"]').addClass('active');
            }
          });
        }
      }, 200);
    });
  }
  // HTML DOM FORM RESET handling
  $(document).on('reset', function (e) {
    var formReset = $(e.target);
    if (formReset.is('form')) {
      formReset
        .find(input_selector)
        .removeClass('valid')
        .removeClass('invalid');
      formReset.find(input_selector).each(function () {
        var inputId = $(this).attr('id');
        if ($(this).attr('value') === '') {
          $('label[for="' + inputId + '"]').removeClass('active');
        }
      });
      // Reset select
      formReset.find('select.initialized').each(function () {
        var reset_text = formReset.find('option[selected]').text();
        formReset.siblings('input.select-dropdown').val(reset_text);
      });
    }
  });

  // Add active when element has focus
  $(document).on('focus change keyup', input_selector, function () {
    var inputId = $(this).attr('id');
    $('label[for="' + inputId + '"]').addClass('active');
    $('label[for="' + inputId + '"]').addClass('focusing');
    $(this).siblings('.prefix').addClass('active');
  });

  $(document).on('blur change keyup', input_selector, function () {
    var $inputElement = $(this);
    var selector = '.prefix';
    var inputId = $(this).attr('id');
    if (
      $inputElement.val().length === 0 &&
      $inputElement[0].validity.badInput !== true
    ) {
      $('label[for="' + inputId + '"]').removeClass('active');
      $('#' + inputId).removeClass('valid');
    }
    $('label[for="' + inputId + '"]').removeClass('focusing');
    $inputElement.siblings(selector).removeClass('active');
  });

  updateTextFields();

  $('#customer_login').validate({
    // use highlight and unhighlight
    highlight: function (element, errorClass, validClass) {
      $(element.form)
        .find('label[for=' + element.id + ']')
        .addClass('error');
      if (element.type === 'radio') {
        this.findByName(element.name)
          .addClass(errorClass)
          .removeClass(validClass);
      } else {
        $(element).addClass(errorClass).removeClass(validClass);
      }
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element.form)
        .find('label[for=' + element.id + ']')
        .removeClass('error');
      if (element.type === 'radio') {
        this.findByName(element.name)
          .removeClass(errorClass)
          .addClass(validClass);
      } else {
        $(element).removeClass(errorClass).addClass(validClass);
      }
    },
  });
  //DropdownCollapse
  $('.page-custom__quest').ready(function () {
    $('.page-show-hide-content').click(function () {
      $(this).removeClass('change');
      $(this).addClass('change');

      $('.page-show-hide-content').each((index, item) => {
        if ($(item).hasClass('change')) {
          if (!$(item).next().is(':hidden')) {
            $(item).removeClass('change');
          } else {
            $(item).addClass('change');
          }
          $(item).next().slideToggle(200);
        } else {
          $(item).next().slideUp(200);
          $(item).removeClass('change');
        }
      });
    });
  });

  // DropdownCollapse Multi
  $('.page-custom__shipping').ready(function () {
    $('.shipping-show-hide-content').click(function () {
      $(this).removeClass('change');
      $(this).addClass('change');

      $(this).each((index, item) => {
        if ($(item).hasClass('change')) {
          if (!$(item).next().is(':hidden')) {
            $(item).removeClass('change');
          } else {
            $(item).addClass('change');
          }
          $(item).next().slideToggle(200);
        } else {
          $(item).next().slideUp(200);
          $(item).removeClass('change');
        }
      });
    });
  });

  /* Product RecentlyViewed */
  Shopify.Products.recordRecentlyViewed();
  Shopify.Products.showRecentlyViewed({
    howManyToShow: 6,
  });

  setTimeout(function () {
    if ($('.card-wrapper').length > 0) {
      $('.card-wrapper').removeClass('card-wrapper--skeleton');
    }
  }, 2000);

  /**
   *
   * Get collection breadcrumb
   */
  if ($('.template-product').length > 0) {
    function capitalizeWords(str) {
      return str.replace(/(^\w|\s\w)/g, function (match) {
        return match.toUpperCase();
      });
    }

    let history = document.referrer
      .replace(/^[^:]+:\/\/[^/]+/, '')
      .replace(/#.*/, '');

    var breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    let path = window.location.pathname;
    let newPath = '/' + path.substring(path.lastIndexOf('/products') + 1);
    let productName = $('.product__info-container .product__title')
      .html()
      .trim();

    if (history.includes('collections')) {
      localStorage.setItem('history', history);
      let colltionPath = localStorage.getItem('history');
      let temp = colltionPath;
      let collection = colltionPath.substring(
        colltionPath.lastIndexOf('collections/') + 'collections/'.length,
        colltionPath.length,
      );
      collection = collection.replace('-', ' ');
      if (collection.includes('?')) {
        let cleanCollection = collection.split('?')[0];
        collection = cleanCollection;
      }

      let html = '<li class="breadcrumbs__item">';
      html +=
        '<a class="breadcrumbs__link breadcrumbs__link--collection" href="' +
        temp +
        '" aria-current="page">' +
        collection +
        '</a></li>';

      $(html).insertAfter('.breadcrumbs__item:first-child');

      let homeLink = window.location.origin;
      var jsonLdData = {
        '@context': 'https://schema.org/',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: homeLink,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: capitalizeWords(collection),
            item: homeLink + temp,
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: productName,
            item: homeLink + newPath,
          },
        ],
      };
    } else {
      localStorage.setItem('history', '');

      let homeLink = window.location.origin;
      var jsonLdData = {
        '@context': 'https://schema.org/',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: homeLink,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: productName,
            item: homeLink + newPath,
          },
        ],
      };
    }
    if (STORE_ENV.permanentDomain == 'synergie-skin.myshopify.com') {
      breadcrumbScript.textContent = JSON.stringify(jsonLdData);
      $('nav.breadcrumbs').append(breadcrumbScript);
    }
  }

  // Featured Product Synternals
  const featuredProductSynternals = $('.section-featured-product-synternals');
  featuredProductSynternals.each(function () {
    const sectionCarousel = $(this).find('.section-carousel');
    const autoplay = sectionCarousel.attr('data-autoplay');
    const sectionCarouselItem = $(this).find('.section-carousel-item');
    if (sectionCarouselItem.length > 1) {
      sectionCarousel.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendDots: $(this).find('.section-carousel-dots'),
        adaptiveHeight: true,
      });
      if (autoplay === 'true') {
        setInterval(function () {
          sectionCarousel.slick('slickNext');
        }, 3000);
      }
    }
    $(this).css('opacity', '1');
  });
  // End

  // Information Synternals
  // Slick carousel
  const informationSynternals = $('.section-information-synternals');
  const resizeObserver = new ResizeObserver(function () {
    informationSynternals.each(function () {
      const sectionCarouselItem = $(this).find('.section-carousel-item');
      $(this)
        .find(
          '.section-carousel-item .section-carousel-item-image-hotspot.active',
        )
        .each(function () {
          imageHotspotOpen(
            null,
            $(this).find('.section-carousel-item-image-hotspot-icon-part'),
          );
        });
    });
  });
  informationSynternals.each(function () {
    const sectionCarousel = $(this).find('.section-carousel');
    const autoplay = sectionCarousel.attr('data-autoplay');
    const sectionCarouselItem = $(this).find('.section-carousel-item');
    if (sectionCarouselItem.length > 1) {
      sectionCarousel.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendDots: $(this).find('.section-carousel-dots'),
        adaptiveHeight: true,
      });
      if (autoplay === 'true') {
        setInterval(function () {
          sectionCarousel.slick('slickNext');
        }, 3000);
      }
    }
    resizeObserver.observe(this);
    $(this).css('opacity', '1');
  });

  // Image hotspot
  const imageHotspot = $(
    '.section-information-synternals .section-carousel-item-image-hotspot-icon-part',
  );
  imageHotspot.click(imageHotspotOpen);
  function imageHotspotOpen(event, imageHotspotActive) {
    let target = null;
    if (event == null) {
      target = imageHotspotActive;
    } else {
      target = $(event.currentTarget);
    }
    if (target && target.length > 0) {
      target.parent().siblings().removeClass('active');
      target.parent().addClass('active');
      const imageHotspotTextEl = target
        .parents('.section-carousel-item')
        .find(
          '.section-carousel-item-text-right .section-carousel-item-subtext',
        );
      imageHotspotTextEl.css('visibility', 'hidden');
      imageHotspotTextEl.empty();
      imageHotspotTextEl.html(
        target
          .siblings('.section-carousel-item-image-hotspot-text-part')
          .html(),
      );
      imageHotspotTextEl.css(
        'color',
        target
          .siblings('.section-carousel-item-image-hotspot-text-part')
          .css('color'),
      );
      if ($(window).width() > 749) {
        target
          .parents('.section-carousel-item')
          .find('.section-carousel-item-text-right')
          .css('width', 'calc(23.8% - 30px)');
        const spaceDisplayText =
          target.parents('.section-carousel-item').height() -
          (target.parent().offset().top -
            target.parents('.section-carousel-item-image').offset().top) -
          (target.parents('.section-carousel-item').height() -
            target.parents('.section-carousel-item-image').height()) /
            2 -
          39;
        let offsetTop = null;
        if (spaceDisplayText > imageHotspotTextEl.height()) {
          offsetTop =
            target.parent().offset().top -
            target.parents('.section-carousel-item-image').offset().top +
            (target.parents('.section-carousel-item').height() -
              target.parents('.section-carousel-item-image').height()) /
              2 +
            39 +
            'px';
        } else {
          offsetTop =
            target.parent().offset().top -
            target.parents('.section-carousel-item-image').offset().top +
            (target.parents('.section-carousel-item').height() -
              target.parents('.section-carousel-item-image').height()) /
              2 -
            imageHotspotTextEl.height() +
            'px';
        }
        imageHotspotTextEl.css('top', offsetTop);
      } else {
        const spaceDisplayText = target.parent().offset().left + 32 + 24 - 16;
        if (
          spaceDisplayText >
          target.parents('.section-carousel-item-image').width() / 2
        ) {
          target
            .parents('.section-carousel-item')
            .find('.section-carousel-item-text-right')
            .css(
              'width',
              `calc(100% - ${
                target.parents('.section-carousel-item-image').width() -
                (target.parent().offset().left - 24 - 16)
              }px)`,
            );
          target
            .parents('.section-carousel-item')
            .find('.section-carousel-item-text-right')
            .css('margin-right', 'auto');
          target
            .parents('.section-carousel-item')
            .find('.section-carousel-item-text-right')
            .css('margin-left', '0');
        } else {
          target
            .parents('.section-carousel-item')
            .find('.section-carousel-item-text-right')
            .css('width', `calc(100% - ${spaceDisplayText}px)`);
          target
            .parents('.section-carousel-item')
            .find('.section-carousel-item-text-right')
            .css('margin-right', '0');
          target
            .parents('.section-carousel-item')
            .find('.section-carousel-item-text-right')
            .css('margin-left', 'auto');
        }
        if (target.parents('.section-carousel').hasClass('slick-slider')) {
          target.parents('.section-carousel').slick('setPosition');
        }
      }
      imageHotspotTextEl.css('visibility', 'visible');
    }
  }
  // End

  // Featured In Synternals
  const featuredInSynternals = $('.section-featured-in-synternals');
  featuredInSynternals.each(function () {
    const sectionCarousel = $(this).find('.section-carousel');
    const autoplay = sectionCarousel.attr('data-autoplay');
    const sectionCarouselItem = $(this).find('.section-carousel-item');
    if (sectionCarouselItem.length > 6) {
      sectionCarousel.slick({
        infinite: true,
        arrows: false,
        variableWidth: true,
      });
      if (autoplay === 'true') {
        setInterval(function () {
          sectionCarousel.slick('slickNext');
        }, 3000);
      }
    }
    $(this).css('opacity', '1');
  });
  // End

  // Featured Product List Synternals
  const featuredProductlistSynternals = $('.section-product-list-synternals');
  featuredProductlistSynternals.each(function () {
    const sectionCarousel = $(this).find('.section-carousel');
    const autoplay = sectionCarousel.attr('data-autoplay') === 'true';
    const sectionCarouselItem = $(this).find('.section-carousel-item');
    if (sectionCarouselItem.length > 1) {
      const breakpoint =
        282 * sectionCarouselItem.length +
        24 * (sectionCarouselItem.length - 1) +
        16;
      sectionCarousel.slick({
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        variableWidth: true,
        swipe: false,
        responsive: [
          {
            breakpoint: breakpoint,
            settings: {
              swipe: true,
              autoplay: autoplay,
            },
          },
        ],
      });
    }
    $(this).css('opacity', '1');
  });
  // End

  // Featured Blog Synternals
  const featuredBlogSynternals = $('.section-featured-blog-synternals');
  featuredBlogSynternals.each(function () {
    const sectionCarousel = $(this).find('.section-carousel');
    const autoplay = sectionCarousel.attr('data-autoplay') === 'true';
    const sectionCarouselItem = $(this).find('.section-carousel-item');
    if (sectionCarouselItem.length > 1) {
      const breakpoint =
        384 * sectionCarouselItem.length +
        24 * (sectionCarouselItem.length - 1) +
        16;
      sectionCarousel.slick({
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        variableWidth: true,
        swipe: false,
        responsive: [
          {
            breakpoint: breakpoint,
            settings: {
              swipe: true,
              autoplay: autoplay,
            },
          },
        ],
      });
    }
    $(this).css('opacity', '1');
  });
  // End

  // FAQ Synternals
  const sectionAccordionHeading = $(
    '.section-faq-synternals .section-accordion-heading',
  );
  sectionAccordionHeading.click(function () {
    $(this).siblings().slideToggle(200);
    $(this).parent().toggleClass('active');
    $(this).parent().siblings().find('.section-accordion-content').slideUp(200);
    $(this).parent().siblings().removeClass('active');
  });
  // End
});

// begin minicart
$(function () {
  $('.mini-cart-wrapper').removeClass('hidden');
  var cartControl = {
    isOpen: false,
    $ListItem: $('.mini-cart-wrapper .list-container'),
    openCart: function () {
      $('body').addClass('open-minicart');
      $('html').addClass('open-minicart');
      $('.mini-cart-wrapper').addClass('show');
      this.isOpen = true;
      bodyScrollLock.disableBodyScroll(this.$ListItem[0]);
    },
    closeCart: function () {
      this.isOpen = false;
      $('body').removeClass('open-minicart');
      $('html').removeClass('open-minicart');
      bodyScrollLock.clearAllBodyScrollLocks();
      $('.mini-cart-wrapper').removeClass('show');
    },
    rewriteListItem: function () {
      this.$ListItem = $('.mini-cart-wrapper .list-container');

      if ($('.mini-cart-wrapper').hasClass('show') || this.isOpen) {
        bodyScrollLock.disableBodyScroll(this.$ListItem[0]);
      }
      return this;
    },
  };

  $(document).on('click', '.mini-cart-overlay', function (e) {
    cartControl.closeCart();
  });

  // This was from the AU store. TICKET: CDSD-26305
  window['cartControl'] = cartControl;
  // end

  $(document).on('click', '.btn-add-to-cart', function (e) {
    e.preventDefault();
    var btn = $(this);
    var vId = btn.data('id');
    btn.addClass('ajax-loader-btn');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id=' + vId,
      dataType: 'json',
      xhrFields: {
        withCredentials: true,
      },
      success: function (lineitem) {
        btn.removeClass('ajax-loader-btn');
        let callback = function () {};
        if ($('.mini-cart-wrapper').hasClass('show')) {
          cartControl.closeCart();
        } else {
          cartControl.openCart();
        }
        refreshMiniCart(lineitem, 1);
      },
      error: function (XMLHttpRequest, textStatus) {
        btn.removeClass('ajax-loader-btn');

        if (textStatus === 'error') {
          if (btn.next().hasClass('add-cart-error')) return;

          let message = $('<div>')
            .append($('<span>').text(XMLHttpRequest.responseJSON.description))
            .addClass('add-cart-error');
          message.insertAfter(btn);

          setTimeout(() => {
            message.fadeOut(function () {
              message.remove();
            });
          }, 2500);
        }
      },
    });
  });

  function bubbleCount() {
    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function (cart) {
        const itemCount = cart.item_count;
        $('.cart-count-bubble').text(itemCount);

        if (itemCount > 0) {
          $('.cart-count-bubble').removeClass('visually-hidden');
        } else {
          $('.cart-count-bubble').addClass('visually-hidden');
        }
        //console.log('Item count:', itemCount);
      },
      error: function (error) {
        console.error('Error fetching cart details:', error);
      },
    });
  }

  /* MINICART FUNCTIONS */
  function refreshMiniCart(lineitem, quantity, callback) {
    if ($('body').hasClass('template-cart')) {
      window.location.reload();
    } else {
      window.checkCart();
      bubbleCount();
    }
  }

  $('#cart-icon-bubble').on('refresh', function () {
    refreshMiniCart();
  });

  // Toggle mini-cart
  $(
    'body:not(.template-cart) .header__icon.header__icon--cart:not(.disabled)',
  ).on('click', function (e) {
    e.preventDefault();

    if ($('.mini-cart-wrapper').hasClass('show')) {
      cartControl.closeCart();
    } else {
      cartControl.openCart();
    }
  });

  // Close minicart
  $(document).on('click', '.close-minicart,.bg-minicart-close', function (e) {
    cartControl.closeCart();
  });

  // Remove minicart
  $(document).on('click', '.cart-details .remove-item', function (e) {
    e.preventDefault();
    var id = $(this).parents('.product-form-item').data('id');

    if (id) {
      $('.mini-cart-content #mincart-loading').show();
      $.ajax({
        method: 'POST',
        url: '/cart/update.js',
        data: 'updates[' + id + ']=0',
        dataType: 'json',
        success: function (response) {
          if (response['item_count'] == 0) {
            $('#close-cart').trigger('click');
          }
          const allFree = response.items.some((item) => item.line_price !== 0);
          if (!allFree) {
            fetch(`${routes.cart_clear_url}`, {...fetchConfig()})
              .then((response) => response.json())
              .then(() => {
                refreshMiniCart();
              });
          }
          refreshMiniCart();
        },
        error: function (XMLHttpRequest, textStatus) {
          $('.mini-cart-content #mincart-loading').hide();
          // handleError(XMLHttpRequest);
        },
      });
    }
  });

  // TICKET: CDSD-26305. Wasnt async on NZ store
  $(document).on(
    'change',
    '.quantity.cart .quantity__input',
    async function (e) {
      let that = $(this);
      let item_id = $(this).closest('.product-form-item').data('id');
      let qty = parseInt(that.val());
      let max = that.data('max');
      let message = that.data('message');
      let template_message = $('#template_message').html();

      if (max && qty > max && message && template_message) {
        that.val(max);
        message = message.replace('$item', max);
        let elementMessage = that.parents('.cart-item').next();
        if (
          elementMessage.length > 0 &&
          elementMessage.children().length == 0
        ) {
          let div = $(template_message.replace('$message', message));
          div.css('display', 'none');
          elementMessage.html(div);
          div.fadeIn(500);
          setTimeout(function () {
            div.fadeOut(500, function () {
              div.remove();
            });
          }, 10000);
        }
        return;
      }
      $('.mini-cart-content #mincart-loading').show();
      if (qty < 0) {
        qty = 1;
        updateMinicart(item_id, qty);
      } else {
        updateMinicart(item_id, qty);
      }
    },
  );

  // Update Minicart
  async function updateMinicart(product_id, product_quantity) {
    var id = product_id;
    var qty = product_quantity;
    $.ajax({
      method: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + id + ']=' + qty,
      dataType: 'json',
      success: function (response) {
        $('.mini-cart-content #mincart-loading').show();
        window.checkCart();
        bubbleCount();
      },
      error: function (XMLHttpRequest, textStatus) {
        $('.mini-cart-content #mincart-loading').hide();
        //handleError(XMLHttpRequest);
      },
    });
  }
});
// end minicart

// start js product
$(function () {
  function init_accordion($this) {
    let options = {
      active: '.active',
      item: '.accordion__item:not(.disabled)',
      ancient: '.init-accordion',
      content: '.accordion__item-content',
      header: '.accordion__item-header',
    };
    $this.find(options.item + options.active).each(function () {
      $(this).find(options.content).slideDown(300);
    });
    $this.find(options.item + ' ' + options.header).on('click', function () {
      let item = $(this).parents(options.item);
      let parent = $(this).parents(options.ancient);
      let isActive = item.hasClass(options.active.replace('.', ''));
      parent.find(options.item + options.active).each(function () {
        $(this).removeClass(options.active.replace('.', ''));
        $(this).find(options.content).slideUp(300);
      });

      if (!isActive) {
        item.addClass(options.active.replace('.', ''));
        item.find(options.content).slideDown(300);
      }
    });
    if ($this.find(options.item).length > 0) $this.addClass('initialized');
  }
  $('.init-accordion').each(function () {
    init_accordion($(this));
  });

  $('.init-accordion').on('init', function () {
    init_accordion($(this));
  });

  $('.image-video-with-text').each(function () {
    let _this = $(this);
    _this.find('.play').on('click', function (e) {
      _this.addClass('active');
      _this.find('.video').trigger('play');
    });
  });

  $('.image-video-with-text .video').on('play', function (e) {
    $(this).attr('autoplay', 'autoplay');
  });
  (function () {
    let contain = $('.accordion-read-more');
    if (contain.length == 0) return;
    $('.accordion-read-more .inner-less').each(function () {
      for (let i in this.childNodes) {
        if (this.childNodes[i].data && this.childNodes[i].data.match(/^\s*$/)) {
          this.childNodes[i].remove();
        }
      }
      if (
        this.childNodes[this.childNodes.length - 1].nodeName.toLowerCase() ==
        'br'
      ) {
        this.childNodes[this.childNodes.length - 1].remove();
      }
    });
    contain.on('click', '[data-action]', function (e) {
      e.preventDefault();
      let action = $(this).data('action');
      if (action === 'more') {
        contain.addClass('open');
      } else if (action === 'less') {
        contain.removeClass('open');
      }
    });
  })();
});
// end js product

// start popup afterpay

$(function () {
  let popup = $('.popup_afterpay');

  if (popup.length == 0) return;

  popup.appendTo('body');
  popup
    .find('.popup_afterpay--bg, .popup_afterpay--close')
    .on('click', function (e) {
      e.preventDefault();
      popup.fadeOut(300, function () {
        popup.removeClass('active');
      });
    });
  $('body').on('click', '.open_afterpay', function () {
    if (popup.hasClass('active')) {
      popup.fadeOut(300, function () {
        popup.removeClass('active');
      });
    } else {
      popup.fadeIn(300, function () {
        popup.addClass('active');
      });
    }
  });
});
// end popup afterpay

// Header js

$(document).ready(function () {
  $('.search__button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(window).width() < 768) {
      $('.boost-pfs-search-suggestion-mobile-top-panel').addClass('active');
      document.getElementById('boost-pfs-search-box-mobile').focus();
    } else {
      $('.search-modal').addClass('active');
      $(this).closest('.header__search').addClass('active');
      $('.boost-pfs-search-suggestion').addClass('search-open');
      document.getElementById('boost-pfs-search-box-0').focus();
    }
  });

  $('.search-modal__close-button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('.header__search').removeClass('active');
    $('.search-modal').removeClass('active');
    $('.boost-pfs-search-suggestion').removeClass('search-open');

    document.querySelector('.custom-search-input').value = '';
    const searchResults = document.getElementById('search-results');
      if (searchResults) {
        $(searchResults).fadeOut();
      }
  });

  document.addEventListener('click', function (event) {
    if (!event.target.matches('.custom-search-input')) {
      const searchResults = document.getElementById('search-results');
      if (searchResults) {
        document.querySelector('.custom-search-input').value = '';
        $(searchResults).fadeOut();
      }
    }
  });

  $('.search__input').click(function (e) {
    e.stopPropagation();
  });

  $('.header__search').click(function (e) {
    e.stopPropagation();
  });

  $('.header').click(function () {
    $('.header__search').removeClass('active');
  });

  $('.header__menu-item-content').mouseover(function () {
    $('.header__menu-item-content').removeClass('active');
    $(this).addClass('active');
    $('body').addClass('overlay');
  });

  $('.list-menu.list-menu--inline').mouseleave(function () {
    $('.header__menu-item-content').removeClass('active');
    $('body').removeClass('overlay');
  });
  $('.list-menu.list-menu--inline > li > a').mouseover(function () {
    $('.header__menu-item-content').removeClass('active');
    $('body').removeClass('overlay');
  });

  $('.close-menu').click(function (e) {
    e.preventDefault();
    $('.header__icon--menu').trigger('click');
    $('.submenu-close-button').trigger('click');
  });

  $('summary.menu-drawer__menu-item').click(function () {
    $('#menu-drawer').scrollTop(0);
    $('#menu-drawer').addClass('submenu-open');
  });

  $('button.submenu-close-button').click(function () {
    $('.main-menu').removeClass('active');
    $('.submenu-content').removeClass('active');
    $('.submenu-content .menu-drawer__submenu').removeClass('active');
  });

  $(document).on(
    'click',
    '.boost-pfs-search-btn-clear-suggestion',
    deactiveSearch,
  );

  let clicked = false;
  /*$(document).on("touchstart", function () {
       clicked = true
    })

    $(document).on("touchmove", function () {
       clicked = false
    })*/

  $(document).on('click touchend', function (e) {
    if (e.type === 'click') {
      clicked = true;
    }

    // CDSD-26305: Not in NZ store: $(e.target).closest(".announcement-bar-content").length === 0
    if (
      clicked &&
      $(e.target).closest('.boost-pfs-search-suggestion-mobile-top-panel')
        .length === 0 &&
      $(e.target).closest('.boost-pfs-search-suggestion-wrapper').length ===
        0 &&
      $(e.target).closest('.announcement-bar-content').length === 0
    ) {
      deactiveSearch();
    }
  });

  $('.main-menu a').click(function (e) {
    var menuData = $(this).data('menu');
    if (menuData) {
      if (
        window.location.href.includes('?#') &&
        $(this).attr('href').includes('?#')
      ) {
        e.preventDefault();
        $('header-drawer #close-menu').trigger('click');
        const sectionId = $($(this).attr('href').split('?')[1]);
        $('html, body').animate(
          {
            scrollTop: sectionId.offset().top,
          },
          1000,
        );
      } else {
        $('.menu-drawer__menu.main-menu').addClass('active');
        $('.submenu-content').addClass('active');
        $(
          '.submenu-content .menu-drawer__submenu[data-menu="' +
            menuData +
            '"]',
        ).addClass('active');
      }
    }
  });

  // play video
  $('.card-wrapper')
    .find('.video-card')
    .each(function () {
      var target = $(this);
      if (target.find('video').length > 0) {
        let video = target.find('video');
        $(video).attr('muted', 'muted');
        $(video).on('canplay', function () {
          $(video)
            .mouseenter(function () {
              $(this).get(0).play();
            })
            .mouseleave(function () {
              $(this).get(0).pause();
            });
        });
      }
      if (target.find('iframe').length > 0) {
        let iframe = target.find('iframe');
        let url = new URL($(iframe).attr('src'));
        $(iframe)
          .mouseenter(function () {
            url.searchParams.append('autoplay', 1);
            $(iframe).attr('src', url.href);
          })
          .mouseleave(function () {
            url.searchParams.delete('autoplay');
            $(iframe).attr('src', url.href);
          });
      }
    });
});

function deactiveSearch() {
  $('.header__search').removeClass('active');
  $('.search-modal').removeClass('active');
  $('.boost-pfs-search-suggestion-mobile-top-panel').removeClass('active');
  $('.boost-pfs-search-suggestion-wrapper').hide();
  $('.boost-pfs-search-suggestion-wrapper').removeClass(
    'boost-pfs-search-suggestion-open',
  );
  // CDSD-26305: Not in NZ store
  $('.boost-pfs-search-suggestion').removeClass('search-open');
}

// End header js
// function reorder - account details page
function reOrder(el) {
  let size = $(el).attr('data-size');
  let names = $(el)
    .attr('data-variant-names')
    .substring(0, $(el).attr('data-variant-ids').length - 1)
    .split(',');
  let ids = $(el)
    .attr('data-variant-ids')
    .substring(0, $(el).attr('data-variant-ids').length - 1)
    .split(',');
  let qty = $(el)
    .attr('data-variant-quantities')
    .substring(0, $(el).attr('data-variant-quantities').length - 1)
    .split(',');
  let inventoryQty = $(el)
    .attr('data-variant-inventories')
    .substring(0, $(el).attr('data-variant-inventories').length - 1)
    .split(',');
  console.log(inventoryQty);
  let samples = $(el)
    .attr('data-variant-samples')
    .substring(0, $(el).attr('data-variant-samples').length - 1)
    .split(',');

  var itemsSelected = new Array();
  var add = true;
  var messages = new Array();
  for (let i = 0; i < size; i++) {
    if (samples[i] == 'sample') {
      messages.push(
        names[i] + ' is a free sample so please select in cart page',
      );
      add = false;
    } else {
      if (inventoryQty[i] == '') {
        messages.push(names[i] + ' does not exist');
        add = false;
      } else if (inventoryQty[i] < qty[i]) {
        messages.push(names[i] + ' in stock are not enough');
        add = false;
      } else {
        itemsSelected.push({
          id: ids[i],
          quantity: qty[i],
        });
      }
    }
  }

  // add to cart
  if (add == true) {
    let dataAdd = {
      items: itemsSelected,
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataAdd),
    })
      .then((response) => {
        console.log(response);
        if (response.ok == false) {
          return response.json();
        } else {
          location.reload();
          document.location = '/cart';
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  } else {
    var messHtml =
      "<div class='form-message form-message--error' tabindex='-1'>";
    messHtml += '<div>Please notice:</div>';
    messHtml += '<ul>';
    for (let item in messages) {
      messHtml += '<li>';
      messHtml += messages[item];
      messHtml += '</li>';
    }
    messHtml += '</li>';
    messHtml += "<label class='close-notification'>";
    messHtml +=
      "<img src='" +
      $('.account-page-wrapper .img-hidden').val() +
      "' alt='Close Notification'>";
    messHtml += '</label>';
    messHtml += '</div>';
    $('.account-content__main').prepend(messHtml);
  }
}

// start blog landing page
$(function () {
  let triggered = false;

  function loadmore(nextUrl) {
    let moreButon = $('#loadmore').last();
    if (triggered) return;
    triggered = true;
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function () {
        moreButon.attr('disabled', 'true');
        moreButon.addClass('loading');
      },
    }).done(function (data) {
      $('.blog-articles').append($(data).find('.blog-articles').html());

      let button = $(data).find('.main-blog__bottom');

      if (!button.find('button').data('next-page')) {
        moreButon.remove();
      } else {
        $('.main-blog__bottom').html(button.html());
      }
      triggered = false;
    });
  }

  $(document).ready(function () {
    $('.template-blog .main-blog').on('click', '#loadmore', function () {
      let link = $(this).data('next-page');
      link && loadmore(link);
    });
  });
});
// end blog landing page

// start article page
$(function () {
  let product_grid = $('.carousel-product').slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    infinite: false,
    waitForAnimate: false,
    touchThreshold: 15,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          variableWidth: true,
        },
      },
    ],
  });

  product_grid.on('swipe', function (event, slick, direction) {
    let item_width = slick.slideWidth ?? slick.$slides[0].offsetWidth;
    let current_left = slick.currentLeft;
    let current_slide = slick.currentSlide;
    let current_item_position = current_slide * item_width;
    let max_dot = slick.$dots.find('li').length;
    if (current_item_position + item_width + current_left < 0) {
      let goto =
        current_slide +
        Math.abs((current_left + current_item_position) / item_width);

      if (goto > max_dot) goto = max_dot - 1;

      $(this).slick('slickGoTo', goto);
    }
    // left
  });
});
// end article page

// start stockist page
(function (w, $) {
  class stockists {
    constructor() {
      this.promiseAddress;
      this.key;
      this.label;
      this.account;
      this.template;
      this.ignoreGroup;
      this.country;
    }
    accountBy(value) {
      this.account = value;
      return this;
    }

    beforeLoadData(callback) {
      this._beforeLoadData = callback;
      return this;
    }
    loadData() {
      var country = this.country;
      var group = this.group;
      var ignoreGroup = this.ignoreGroup;
      var _this = this;
      var lowerCase;
      var order_by_state;
      this.promiseAddress = new Promise(function (resolve, reject) {
        function json(data) {
          return data;
        }
        try {
          $.get(
            'https://stockist.co/api/v1/' +
              _this.account +
              '/locations/all.js?callback=json',
            function (data, status) {
              if (status == 'success') {
                order_by_state = {};
                data = eval(data);

                if (typeof _this._beforeLoadData === 'function')
                  data = _this._beforeLoadData(data);
                for (let item of data) {
                  if (country && item.country != country) continue;

                  // ignore group if null
                  if (item[group] == null) continue;

                  // ignore group has set
                  lowerCase = item[group]
                    .trim()
                    .replace(/\s/, '_')
                    .toLowerCase();
                  if (
                    ignoreGroup &&
                    typeof ignoreGroup[lowerCase] != 'undefined' &&
                    ignoreGroup[lowerCase] == true
                  )
                    continue;

                  // group by
                  let key = item[group],
                    value;
                  value = item;
                  if (
                    _this.label &&
                    typeof _this.label[lowerCase] !== 'undefined'
                  ) {
                    key = _this.label[lowerCase];
                  }

                  if (!order_by_state[key]) {
                    order_by_state[key] = [];
                  }
                  order_by_state[key].push(item);
                }

                resolve({
                  data: order_by_state,
                });
              } else {
                throw new Error('Error');
              }
            },
          );
        } catch (error) {
          reject(error);
        }
      });
      return this;
    }

    ignoreGroupBy(item) {
      this.ignoreGroup = item;

      return this;
    }

    groupBy(data) {
      this.group = data;
      return this;
    }

    labelBy(data) {
      this.label = data;
      return this;
    }

    templateBy(template) {
      this.template = {
        list: template.list,
        item: template.item,
      };
      return this;
    }

    where(country) {
      this.country = country;
      return this;
    }

    main(source) {
      let html = '',
        html_item,
        list_key,
        get,
        data = source.data;
      for (let label in data) {
        html_item = '';
        for (let item of data[label]) {
          get = function (data) {
            if (typeof data == 'function') return data.call(this, item);
            if (typeof item[data] !== 'undefined' && item[data]) {
              return item[data];
            } else {
              return '';
            }
          }.bind(this);
          html_item += eval('`' + this.template.item + '`');
        }

        try {
          let _lable = this.label;
          get = function (data) {
            let data_provide = {
              html_item: html_item,
              label: {
                data: label,
                run: function (data) {
                  if (!data || data == 'null')
                    throw new Error('Cannot find label');
                  data = data.trim().replace(/\s/, '_').toLowerCase();
                  return typeof _lable[data] !== 'undefined'
                    ? _lable[data]
                    : label;
                },
              },
            };
            if (
              typeof data_provide[data] !== 'undefined' &&
              data_provide[data]
            ) {
              if (typeof data_provide[data]['run'] == 'function') {
                return data_provide[data].run(data_provide[data].data);
              }
              return data_provide[data];
            } else {
              return '';
            }
          };
          html += eval('`' + this.template.list + '`');
        } catch (error) {
          console.log(error);
          continue;
        }
      }
      $('.init-accordion').html(html);
      $('.init-accordion').trigger('init');
    }

    run() {
      this.promiseAddress.then(this.main.bind(this)).catch(function (data) {
        console.log(data);
      });
    }
  }

  w.stockists = stockists;
})(window, jQuery);
//end stockist page
